<template lang="pug">
ws-dialog(v-model="showform" :title="$t('weathermap.animator.download')")
  v-card-text.mt-3
    form.mb-2
      v-select.mb-3(outlined hide-details="auto" name="start" label="start" v-model="start" :items="startTimes" item-text="label" item-value="hour" )
      v-select.mb-3(outlined hide-details="auto" name="stop" label="eind" v-model="end" :items="endTimes" item-text="label" item-value="hour" )
      v-select.mb-3(outlined hide-details="auto" name='step' label="interval" v-model='step' :items="[3,6,12,24]" )
      v-select.mb-3(outlined hide-details="auto" name='speed' label="snelheid" v-model='speed' :items="[{text: $t('weathermap.animator.speed.normal'), value:3},{text: $t('weathermap.animator.speed.faster'), value:4},{text: $t('weathermap.animator.speed.fastest'), value:5}]" )
  v-card-text.text-center(v-if="showprogress")
    img.mb-3(src="https://static.wintersport.nl/images/content-loader.gif")
  v-card-actions(v-else)
    v-spacer
    v-btn(outlined color="primary" @click='download') {{ $t('weathermap.animator.download') }}
</template>

<script>
export default {
	props: {
		value: { type: Boolean, default: false },
		region: { type: String, required: true },
		pressure: { type: Boolean, default: false },
		type: { type: String, required: true },
		period: { type: Number, default: 0 }
	},
	data() {
		return {
			showform: false,
			start: this.period || 0,
			end: 144,
			step: 3,
			speed: 3,
			showprogress: false,
			staticCdn: '//cdn.wintersport.nl'
		};
	},
	computed: {
		startTimes() {
			const times = [];
			const m = this.$store.state.rundate;

			for (let index = this.period || 0; index <= 144; index += 3) {
				times.push({
					label: this.$dayjs(m).add(index, 'hours').format('ddd D MMM HH:mm'),
					hour: index
				});
			}

			return times;
		},
		endTimes() {
			const times = [];
			const m = this.$store.state.rundate;
			for (let index = this.start; index <= 144; index += 3) {
				times.push({
					label: this.$dayjs(m).add(index, 'hours').format('ddd D MMM HH:mm'),
					hour: index
				});
			}

			return times;
		}
	},
	watch: {
		value(value) {
			this.showform = value;
		},
		showform(value) {
			this.$emit('input', value);
		}
	},
	created() {
		this.showform = this.value;
	},
	methods: {
		closeDialog() {
			this.showform = false;
		},
		download() {
			const a = document.createElement('a');

			let url = `https://www.wintersport.nl/animation/ws/${this.$dayjs().format(
				'YYYY-MM-DD'
			)}/${this.region}?start=${this.start}&stop=${this.end}&step=${
				this.step
			}&speed=${this.speed}&type=${this.type}`;

			if (this.period) url += '&period=' + this.period;

			if (this.pressure) url += '&pressure=true';

			a.href = url;
			const extension = this.end - this.start === 0 ? '.png' : '.mp4';
			a.download =
				this.region +
				'_' +
				window.forecastRunDate +
				'_' +
				this.type +
				extension;

			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);

			this.showprogress = true;

			setTimeout(
				() => {
					this.showprogress = false;
					this.showform = false;
				},
				extension === '.png' ? 2000 : 25000
			);
		}
	}
};
</script>
